// Common mapping for document type values to user-friendly labels
export const documentTypeLabels: Record<string, string> = {
  eicr: "EICR Report",
  epc: "EPC Report",
  manual: "Manual",
  warranty: "Warranty",
  invoice: "Invoice",
  other: "Other"
};
